import React, { ChangeEvent, useEffect, useState } from "react";
import { PropertyProcedure } from "@10x/dubai-rest-api/dist/property_registry/entity";
import { PropertyRegistryApi } from "@10x/dubai-rest-api";
import { getParticipantID } from "@10x/sso";
import Strings from "@my-dld/assets/strings";
import { ProcedureItem } from "@my-dld/screens/MyDLD/ProcedureArchives";
import { SpinnerLoader } from "../SpinnerLoader";

interface Props {
	propertyId: string | number;
	onViewAll: () => void;
}

export function PropertyDocuments( props: Props ) {
	const { propertyId } = props;
	const ownerId = getParticipantID();
	const [ loading, setLoading ] = useState( false );
	const [ procedures, setProcedures ] = useState<PropertyProcedure[]>( [] );
	const [ query, setQuery ] = useState( "" );
	const onQueryChange = ( e: ChangeEvent<HTMLInputElement> ) => {
		setQuery( e.target.value );
	};
	useEffect( () => {
		if ( ownerId ) {
			setLoading( true );
			PropertyRegistryApi.getPropertyProcedures( propertyId ).then( x => {
				x = x.sort( ( a: PropertyProcedure, b: PropertyProcedure ) => {
					const av = a.instanceDate.asDate().getTime();
					const bv = b.instanceDate.asDate().getTime();
					return bv - av;
				} );
				setProcedures( x );
				setLoading( false );
			} ).catch( e => {
				setLoading( false );
			} );
		}
	}, [ ownerId, propertyId ] );

	return <div className="card procedure-doc">
		<div className="card-body">
			{ loading && <div className={ "d-flex " }><SpinnerLoader/></div> }
			{ procedures.length === 0 && <span>{ Strings.no_data_available }</span> }
			{ procedures.length > 0 && <>
				<div className="row">
                    <div className="col-md-12">
                        <div className="position-relative w-100 mb-3">
                            <label className="sr-only" htmlFor="mydldPropServicelist">{Strings.search}</label>
                            <input type="text" id="mydldPropServicelist" className="form-control search-field-icon" onChange={onQueryChange} placeholder={Strings.search} />
                            <button className="btn txt-clear-btn" type="button"><i className="material-icons-outlined">close</i></button>
                        </div>
				    </div>
					{ procedures.slice( 0, 2 ).map( ( p: PropertyProcedure, ix: number ) =>
                        <ProcedureItem key={`procedure_doc_${ix}`} procedure={p} query={query} />)}

                    {procedures.length > 2 && <div>
                        <button className="btn btn-grey" type="button" onClick={props.onViewAll}>{Strings.view_all}</button>
                    </div>}
				</div>
			</> }
		</div>
	</div>;
}
